<footer class="footer-area text-center bg-white">
    <p>
        © <span class="text-black fw-semibold">OPB</span> - Powered By
        <a href="https://upg.cl" target="_blank" class="text-primary fw-medium"
            >UPG</a
        >
    </p>
</footer>
